// Copyright (c) 2017 Deere & Company

import * as helpers from './get-lead-account-helper';
import actions from '../../actions-list';

export const updateFilteredTerritories = (territories, text) =>
    dispatch => {

        const textToSearch = new RegExp(text, 'i');
        const filteredTerritories = helpers.filterTerritories(textToSearch, territories);
        const newSelections = helpers.generateSelectionMap(filteredTerritories);

        dispatch({
            leadAccount: filteredTerritories,
            type: actions.UPDATE_TCSM_AUDIT_FILTERED_TERRITORIES
        });

        const facets = {
            dealers: helpers.getListOfSelectedDealers(newSelections.selectedAccounts),
            ...newSelections
        };

        dispatch({
            facets,
            type: actions.UPDATE_TCSM_AUDIT_DEALER_HIERARCHY_FACET
        });

    };



// WEBPACK FOOTER //
// ./src/tcsm/audits/action-creators/filtered-territories.js